export default "/images/ipaymer-light.svg?d65bf10c537841f22cd7cede76d05c25";